const main_section_followus_swiper = new Swiper('.main-section-followus_slide', {
  spaceBetween: 0,
  slidesPerView: 3,
  grid: {
    rows: 2,
    fill: 'row',
  },
  loop: false,
  allowTouchMove: true,
  autoplay: {
    enabled: false,
  },
  breakpoints: {
    750: {
      spaceBetween: 58,
      slidesPerView: 3,
      grid: {
        rows: 1,
      },
      loop: true,
      speed: 6000,
      autoplay: {
        enabled: true,
        delay: 0,
      },
    },
  },
});
